import React, { useState, useEffect } from "react";
import { Form, Input, Button, Typography, DatePicker, Row, Col, Spin, message, Card, Space } from "antd";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import SidebarLayout from "../BankerUI/SidebarLayout";
import { routes } from "../../routes/Routes";
import { RightOutlined, UserOutlined, CalendarOutlined, DownloadOutlined, ExpandOutlined, IdcardOutlined, EditOutlined } from '@ant-design/icons';
import _LoanOfficerService from "../../modules/LoanOfficerService";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import _commonService from "../../modules/commonService";
import "../BankAdmin/BankAdminProfile.scss";
import ChangePasswordForm from "../BankAdmin/ChangePasswordForm";

const { Title, Text, Link } = Typography;

const LoanOfficerProfile = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [LoanOfficerInfo, setLoanOfficerInfo] = useState({});
    const LoanOfficerId = localStorage.getItem("LoanOfficerId");
    const LoanOfficerFirstName = localStorage.getItem("LoanOfficerFirstName");
    const LoanOfficerEmail = localStorage.getItem("LoanOfficerEmailId")


    useEffect(() => {
        getLoanOfficerInformationByLoanOfficerId();
    }, []);

    const getLoanOfficerInformationByLoanOfficerId = async () => {
        try {
            setLoading(true);
            // const res = await _LoanOfficerService.getLoanOfficerInformationByLoanOfficerId(LoanOfficerId);
            const res = await _BankerService.getBankerInformationByBankerId(LoanOfficerId);
            if (res?.data?.IsSuccess && res.data.Obj) {
                setLoading(false);
                setLoanOfficerInfo(res.data.Obj);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error("Error fetching banker information:", error);
        }
    };


    const onFinish = async (values) => {
        //history.push(routes.accountLogin.path);
        setLoading(true);
        try {
            const reqObj = {
                Email: LoanOfficerEmail,
                OldPassword: values.currentPassword,
                NewPassword: values.newPassword,
                ConfirmPassword: values.confirmPassword,
            }
            // const res = await _LoanOfficerService.ChangeLoanOfficerPassword(reqObj);
            const res = await _BankerService.ChangeBankerPassword(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                localStorage.setItem("Password", values.newPassword);
                form.resetFields();
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        } finally {
            setLoading(false);

        }
    };

    const validatePassword = (_, value) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@%&!^*.,_+=?]).{8,20}$/;
        if (!value || passwordRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(
            new Error(
                "Password must include uppercase, lowercase, number, special character and be 8-20 characters long"
            )
        );
    };
    const onPersonalEditClick = () => {
        history.push({
            pathname: routes.personalDetailsForLoanOfficer.path,
            state: { LoanOfficerId: localStorage.getItem("LoanOfficerId"), isFromDashboard: true, },
        });
    }
    const onProfessionalEditClick = () => {
        history.push({
            pathname: routes.professionalDetailsForLoanOfficer.path,
            state: { LoanOfficerId: localStorage.getItem("LoanOfficerId"), isFromDashboard: true, },
        });
    }
    return (
        <Spin spinning={loading}>
            <SidebarLayout>
                <Title level={4}>Hello, {LoanOfficerFirstName}!</Title>
                <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                        <Card className="card-section userProfileCardView h100"
                            title={
                                <Row justify="space-between" align="middle" className="balance-heading">
                                    <Text strong>
                                        <span role="img" aria-label="user" style={{ marginRight: 2 }}><UserOutlined /> </span>
                                        Personal Details
                                    </Text>
                                    <EditOutlined onClick={onPersonalEditClick} style={{ color: "#595959", cursor: "pointer" }} />
                                </Row>
                            }
                        >
                            <Row gutter={[12, 24]}>
                                {/* <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary" className="color">Account Type:</Text>
                                    <br />
                                  <Text className="b-bottm">Loan Officer</Text>
                                </Col> */}
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary" className="color">First Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo.FirstName}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Middle Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo.MiddleInitial || "N/A"}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Last Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo.LastName}</Text>
                                </Col>

                                {/* <Col xs={12} sm={12} md={12} lg={12}>
                                   
                                    <Text type="secondary">Joined In</Text>
                                    <br />
                                    <Text className="b-bottm">
                                        {LoanOfficerInfo?.CreatedDate
                                            ? moment(LoanOfficerInfo.CreatedDate).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </Text>
                                   
                                </Col> */}

                                {/* <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Date Of Birth:</Text>
                                    <br />
                                    <Text className="b-bottm">
                                        {LoanOfficerInfo?.DateOfBirth
                                            ? moment(LoanOfficerInfo.DateOfBirth).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </Text>
                                </Col> */}
                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Email:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo.Email}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Contact Number:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo?.ContactNumber ? _commonService.formatUSPhoneNumber(LoanOfficerInfo.ContactNumber) : "N/A"}</Text>
                                </Col>

                               
                            </Row>
                        </Card>
                    </Col>

                   
                    <Col xs={24} md={12} style={{ display: "flex" }}>
                        <Card className="card-section userProfileChangePasswordCardView" style={{ width: "100%", height: "100%" }} >
                            <Title level={5} style={{ fontSize: "18px", textAlign: "center", marginBottom: 16 }}>Change Password</Title>
                            <ChangePasswordForm
                                form={form}
                                onFinish={onFinish}
                                validatePassword={validatePassword}
                            />
                        </Card>
                    </Col>
               

                    {/* <Col xs={24} lg={12}>
                        <Card className="card-section userProfileCardView"
                            title={
                                <Row justify="space-between" align="middle" className="balance-heading">
                                    <Text strong>
                                        <span role="img" aria-label="user" style={{ marginRight: 2 }}><IdcardOutlined /> </span>
                                        Professional Details
                                    </Text>
                                    <EditOutlined onClick={onProfessionalEditClick} style={{ color: "#595959", cursor: "pointer" }} />
                                </Row>
                            }
                        >

                            <Row gutter={[24, 24]} align="top">
                                <Col xs={24} md={14}>
                                    <Row gutter={[0, 16]}>
                                        <Col span={12}><Text type="secondary">Job Role:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.JobRole}</Text></Col>

                                        <Col span={12}><Text type="secondary">Institution Name:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.InstitutionName}</Text></Col>

                                        <Col span={12}><Text type="secondary">Street Address:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.OfficeAddress}</Text></Col>

                                        <Col span={12}><Text type="secondary">City:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.City}</Text></Col>

                                        <Col span={12}><Text type="secondary">State:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.State}</Text></Col>

                                        <Col span={12}><Text type="secondary">Zip Code:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.ZipCode}</Text></Col>

                                        <Col span={12}><Text type="secondary">ID Number:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.IdentificationNumber}</Text></Col> 
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col> */}
                </Row>

                {/* <Row justify="center" style={{ marginTop: 25 }}>
                    <Col xs={24} md={12} style={{ display: "flex" }}>
                        <Card className="card-section userProfileChangePasswordCardView" style={{ width: "100%", height: "100%" }} >
                            <Title level={5} style={{ fontSize: "18px", textAlign: "center", marginBottom: 16 }}>Change Password</Title>
                            <ChangePasswordForm
                                form={form}
                                onFinish={onFinish}
                                validatePassword={validatePassword}
                            />
                        </Card>
                    </Col>
                </Row> */}
            </SidebarLayout>
        </Spin>
    );
};

export default LoanOfficerProfile;
